import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-nowrap" }
const _hoisted_2 = { class: "cart-img" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "card-body ps-0 d-flex flex-column" }
const _hoisted_5 = { class: "cart-item-title" }
const _hoisted_6 = { class: "card-item-price mb-3" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-between flex-grow-1"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "text-nowrap text-ss-grey" }
const _hoisted_11 = { class: "d-flex flex-wrap gap-1" }
const _hoisted_12 = {
  key: 0,
  class: "cart-item-quantity d-flex justify-content-between align-items-center"
}
const _hoisted_13 = ["disabled", "onClick"]
const _hoisted_14 = ["onUpdate:modelValue", "disabled"]
const _hoisted_15 = ["disabled", "onClick"]
const _hoisted_16 = { class: "ms-3 text-nowrap" }
const _hoisted_17 = {
  key: 1,
  class: "d-flex justify-content-between align-items-center flex-grow-1"
}
const _hoisted_18 = {
  class: "input-group",
  id: "donate-input-group"
}
const _hoisted_19 = ["onUpdate:modelValue", "onKeyup", "onBlur", "disabled"]
const _hoisted_20 = { class: "flex-shrink-0" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "text-center py-5 my-5 text-ss-grey"
}

import {
  CInputGroup,
} from '@coreui/bootstrap-vue/src/components/form/index';

import { OrderType, useCartStore } from './cartStore';
import { computed, ref, watch, watchEffect } from 'vue';

import debounce from 'lodash/debounce';

// When you change a quantity, it changes "adjustedQuantities" immediately, but
// doesn't save it to the server. Once it saves then it will match up again

export default /*@__PURE__*/_defineComponent({
  __name: 'cartProductList',
  setup(__props) {


const adjustedQuantities = ref({} as Record<string, number>);
function adjustQuantity(id: string, delta: number, absolute = false) {
  const adjustedValue = absolute ? delta : adjustedQuantities.value[id] + delta;

  // Value must be between 0 and 300
  let newQuantity = Math.min(
    Math.max( adjustedValue, 1 ),
    300
  );
  adjustedQuantities.value[id] = newQuantity;
}

const quantityMap = computed(() => {
  const items = $cartStore.items;
  const quantityMap = Object.fromEntries(items.map((item) => [item.id, item.quantity]));
  return quantityMap;
});

const $cartStore = useCartStore();

const debounceUpdateQty = debounce(async () => {
  try {
    // Find a list of all updated quantities
    const updatedQuantities = Object.entries(adjustedQuantities.value)
      .filter(([id, quantity]) => quantity !== quantityMap.value[id])
      .map(([id, quantity]) => ({ id, quantity }));

    if (updatedQuantities.length === 0) {
      return;
    }

    await $cartStore.updateItemQuantities(updatedQuantities);
  } catch (err) {
    console.warn("Error updating cart:", err);
  }
}, 500);

// converted from 325 -> "3.25"
const adjustedDonations = ref({} as Record<string, string>);
const donationMap = computed(() => {
  const items = $cartStore.items.filter(isDonation);
  const mapped: Record<string, number> = Object.fromEntries(items.map((item) => [item.id, item.unitPrice]));
  return mapped;
});
const debounceUpdateDonations = debounce(async () => {
  try {
    const updatedDonations = Object.entries(adjustedDonations.value)
      .map(([id, donation]) => [id, Math.floor(Number(donation) * 100)] as [string, number])
      .filter(([id, donation]) => donation !== donationMap.value[id]);

    if (!updatedDonations.length) return;
    // it should be almost impossible to get here with multiple donations to update,
    // so I'm not bothering to put in bulk update functionality
    for (const [id, donation] of updatedDonations) {
      const productVariantId = $cartStore.items.find((item) => item.id === id)?.productVariant.id;
      if (!productVariantId) continue;
      await $cartStore.updateDonationAmount(productVariantId, donation);
    }

  } catch (err) {
    console.warn("Error updating cart:", err);
  }
}, 500);

function sanitizeDonation(id: string) {
  const val = Number(adjustedDonations.value[id]);
  if (isNaN(val) || val < 0) {
    adjustedDonations.value[id] = '0.00';
  } else {
    // just using toFixed would change 3.539 to 3.54
    adjustedDonations.value[id] = (Math.floor(val * 100) / 100).toFixed(2);
  }
}

function imageForCard(item: OrderType['lines'][0]) {
  return item.productVariant.featuredAsset?.source
    || item.productVariant.product.featuredAsset?.source;
}

function qUpdatePending(id: string) {
  return (adjustedQuantities.value[id] !== quantityMap.value[id]);
}

function isDonation(item: OrderType['lines'][0]) {
  return item?.productVariant?.customFields?.digitalProductType === 'Donation';
}

watch(adjustedQuantities, debounceUpdateQty, { deep: true });
watch(adjustedDonations, debounceUpdateDonations, { deep: true });
watchEffect(() => {
  adjustedQuantities.value = Object.fromEntries(Object.entries(quantityMap.value).map(([id, quantity]) => [id, quantity]));
  adjustedDonations.value = Object.fromEntries(Object.entries(donationMap.value).map(
    ([id, quantity]) => [id, (quantity / 100).toFixed(2)]
  ));
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" #region Cart item "),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref($cartStore).items, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "cart-item card my-3",
        key: `card-${item.id}`
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: imageForCard(item),
              class: "p-3"
            }, null, 8 /* PROPS */, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.productVariant.name), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_6, [
              (!isDonation(item))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["text-nowrap", {
                'text-ss-grey': !_unref($cartStore).hasItemDiscount(item),
                'text-ss-grey-light': _unref($cartStore).hasItemDiscount(item),
                'text-decoration-line-through': _unref($cartStore).hasItemDiscount(item),
              }])
                    }, _toDisplayString(_unref($cartStore).formatPrice(item.unitPrice)) + " / ea ", 3 /* TEXT, CLASS */),
                    _createElementVNode("div", null, [
                      (_unref($cartStore).activeOrder?.state === 'AddingItems')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "#",
                            color: "btn btn-text text-ss-iris text-decoration-underline",
                            onClick: _withModifiers(($event: any) => (_unref($cartStore).removeFromCart(item.id)), ["prevent"])
                          }, _cache[0] || (_cache[0] = [
                            _createElementVNode("i", { class: "fa-duotone fa-trash pe-2" }, null, -1 /* HOISTED */),
                            _createTextVNode("Remove")
                          ]), 8 /* PROPS */, _hoisted_8))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              (_unref($cartStore).hasItemDiscount(item))
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_unref($cartStore).formatPrice(_unref($cartStore).discountedItemPrice(item))) + " / ea", 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref($cartStore).getItemDiscounts(item), (discount, i) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: i,
                          class: "badge rounded-pill bg-primary"
                        }, [
                          _cache[1] || (_cache[1] = _createElementVNode("i", { class: "fa fa-tag me-1" }, null, -1 /* HOISTED */)),
                          _createTextVNode(_toDisplayString(discount.description), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            (!isDonation(item))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", null, [
                    _createVNode(_unref(CInputGroup), null, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "btn btn-outline-grey",
                          disabled: _unref($cartStore).isLoading > 0 || _unref($cartStore).activeOrder?.state !== 'AddingItems',
                          onClick: ($event: any) => (adjustQuantity(item.id, -1))
                        }, _cache[2] || (_cache[2] = [
                          _createElementVNode("i", { class: "fa-solid fa-minus" }, null, -1 /* HOISTED */)
                        ]), 8 /* PROPS */, _hoisted_13),
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["form-control p-1 text-center w-4rem", {'border-warning': qUpdatePending(item.id), 'border-ss-grey-dark': !qUpdatePending(item.id)}]),
                          type: "text",
                          "onUpdate:modelValue": ($event: any) => ((adjustedQuantities.value[item.id]) = $event),
                          disabled: _unref($cartStore).isLoading > 0 || _unref($cartStore).activeOrder?.state !== 'AddingItems'
                        }, null, 10 /* CLASS, PROPS */, _hoisted_14), [
                          [
                            _vModelText,
                            adjustedQuantities.value[item.id],
                            void 0,
                            {
                              lazy: true,
                              number: true
                            }
                          ]
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-outline-grey",
                          disabled: _unref($cartStore).isLoading > 0 || _unref($cartStore).activeOrder?.state !== 'AddingItems',
                          onClick: _withModifiers(($event: any) => (adjustQuantity(item.id, 1)), ["prevent"])
                        }, _cache[3] || (_cache[3] = [
                          _createElementVNode("i", { class: "fa-solid fa-plus fs-normal" }, null, -1 /* HOISTED */)
                        ]), 8 /* PROPS */, _hoisted_15)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("strong", {
                      class: _normalizeClass(["text-ss-grey-dark fs1_5", {'text-ss-grey-light': qUpdatePending(item.id)}])
                    }, _toDisplayString(_unref($cartStore).formatPrice(_unref($cartStore).discountedLinePrice(item))), 3 /* TEXT, CLASS */)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_18, [
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "input-group-prepend" }, [
                        _createElementVNode("span", { class: "input-group-text" }, "$")
                      ], -1 /* HOISTED */)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control",
                        min: "0",
                        step: "1.00",
                        "aria-label": "Donation amount",
                        placeholder: "0.00",
                        "onUpdate:modelValue": ($event: any) => ((adjustedDonations.value[item.id]) = $event),
                        onKeyup: ($event: any) => (sanitizeDonation(item.id)),
                        onBlur: ($event: any) => (sanitizeDonation(item.id)),
                        disabled: _unref($cartStore).isLoading > 0 || _unref($cartStore).activeOrder?.state !== 'AddingItems'
                      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_19), [
                        [
                          _vModelText,
                          adjustedDonations.value[item.id],
                          void 0,
                          {
                            lazy: true,
                            number: true
                          }
                        ]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    (_unref($cartStore).activeOrder?.state === 'AddingItems')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "#",
                          color: "btn btn-text text-ss-iris text-decoration-underline",
                          onClick: _withModifiers(($event: any) => (_unref($cartStore).removeFromCart(item.id)), ["prevent"])
                        }, _cache[5] || (_cache[5] = [
                          _createElementVNode("i", { class: "fa-duotone fa-trash pe-2" }, null, -1 /* HOISTED */),
                          _createTextVNode("Remove")
                        ]), 8 /* PROPS */, _hoisted_21))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
          ])
        ])
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    (!_unref($cartStore).items?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _cache[6] || (_cache[6] = [
          _createTextVNode(" No items in your cart "),
          _createElementVNode("br", null, null, -1 /* HOISTED */),
          _createElementVNode("i", { class: "fa-duotone fa-tower-cell fa-xl fa-beat-fade my-4" }, null, -1 /* HOISTED */)
        ])))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})